<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />
    

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdservico) }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Nome/Descrição</label>
                <input type="text" v-model="objEdicao.nmservico" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-char30">
                <ManutServicoCdCategoriaSelect v-model:idSelecionado="objEdicao.cdcategoria" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Informações</label>
                <textarea v-model="objEdicao.informacoes" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end row-space">
            <label for="ckAtivo">Ativo</label>
            <input id="ckAtivo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
        </div>


        <div class="row-end">
            <button class="btn-confirm" @click="salvarDados">Salvar</button>
            <button class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarManutServico } from '@/models/ManutServico';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import ManutServicoCdCategoriaSelect from '@/selects/estaticos/ManutServicoCdCategoriaSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close', 'salvo'])
const props = defineProps({idEdicao: {type: Number, default: 0}})

const ckAtivo = ref(false);
const objEdicao = criarManutServico();
const isLoading = ref(false);
const msgAlerta = ref(false);

function cancelForm() {emit('close');}

async function lerDados() {
    try{
        isLoading.value = true;
        if (props.idEdicao > 0) {
            const req = await Api.getCadastroById('manut_servico', props.idEdicao);
            Object.assign(objEdicao, req[0]);
        }else{
            objEdicao.idmunicipio   = globalStore.idmunicipio;
        }
        objEdicao.idlogin           = globalStore.idlogin;
        objEdicao.idusuario         = globalStore.idusuario;
        ckAtivo.value               = objEdicao.ativo === 'S';
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    }finally{isLoading.value = false;}
}

async function salvarDados() {
    try {
        msgAlerta.value = validarDados();
        if (msgAlerta.value) return;
        isLoading.value     = true;
        objEdicao.ativo     = ckAtivo.value ? 'S' : 'N';
        const response      = await Api.genericPut('/cad/manut_servico', objEdicao);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value = false;}
}

function validarDados(){
    let r = Validar.texto(objEdicao.nmservico, "Serviço");
    if (!r.ok) return r.msg;
    return null;
}

onMounted(lerDados)
</script>